module.exports = __webpack_public_path__ + "img/logo.71056a3d.svg";